import React, { useEffect, useState } from "react";

import { BorderOutlined, TableOutlined, MenuOutlined } from "@ant-design/icons";
import { getList } from "services/api/Api";
import { addConnectionsToActionButtons } from "@util/Scripts";
import { getConnectionData, isActivePublicUser } from "../../../util/Scripts";
import { useSelector } from "react-redux";
import { showTitle } from "@util/Scripts";
import { getListV2 } from "../../../services/api/Api";
import { getListV3 } from "../../../services/restAPI/ListsV2";

import AdvertisementListModal from "../WidgetsSettings/AdvertisementList/AdvertisementListSettingsModal";
import CreateChat from "../WidgetsSettings/ChatSettings/CreateChat";
import AdvertisementItem from "../../AdvertisementItem/AdvertisementItem";
import SettingsModal from "../../Modal/SettingsModal";
import Widget from "../../Widget/Widget";
import { RadioGroup, Spin, Radio } from "../../BP2Components";

import "./advertisementList.less";
import ActionsDropdown from "../../ActionsDropdown";
import Pagination from "../../BP2Components/Pagination/Pagination";
import { useIntl } from "react-intl";

const AdvertisementListWidget = ({ value, role, data }) => {
   const intl = useIntl();
   const [rows, setRows] = useState([]);
   const [columns, setColumns] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(true);
   const [metaData, setMetaData] = useState([]);
   const [displayOption, setDisplayOption] = useState(
      value.showDisplayOptions || !value.displayOption ? "displayNormal" : value.displayOption,
   );
   const { currentBoard } = useSelector(({ boards }) => boards);
   const { search } = useSelector(({ settings }) => settings);
   const authUser = useSelector(({ auth }) => auth);
   value.itemsPerPage = parseInt(value?.itemsPerPage) || 10;

   const handleListResponse = (res) => {
      const columnsCopy = [];
      const responseData = isActivePublicUser()
         ? res?.data?.getPublicList
         : (res?.data?.default ?? res.data);
      responseData.columns.map((column) => {
         if (
            ((!!column.options.visible || column.options.resolver) && column.options.techName) ||
            column.techName ||
            column.options.techName === "widget_images"
         ) {
            columnsCopy.push({
               title: column?.label,
               dataIndex: column?.label,
               techName: column?.options?.techName ?? column?.techName,
               precision: column?.options?.precision,
            });
         }
         return null;
      });
      setMetaData(responseData?.meta);

      // Here is connection between widgets handled
      let actionsList =
         responseData.actions ?? responseData.meta.actions ?? responseData.data.actions;
      if (!Array.isArray(actionsList) && typeof actionsList === "object" && actionsList !== null) {
         actionsList = Object.values(actionsList);
      }

      let actions = addConnectionsToActionButtons(
         currentBoard?.connections,
         actionsList,
         value.id,
         value.listId,
         intl,
      );

      let rowsTable = responseData.data.map((row, i) => {
         const obj = {};
         columnsCopy.forEach((column) => {
            if (typeof row[column.dataIndex] === "string") {
               let rowValue = Number(row[column.dataIndex]);
               // This has to check if rowValue is an empty string or not, because Number() makes converts empty string to 0
               if (
                  row[column.dataIndex] &&
                  column.precision &&
                  row[column.dataIndex].length > 0 &&
                  !isNaN(rowValue)
               ) {
                  obj[column.dataIndex] = rowValue.toFixed(column.precision).toString();
               } else {
                  obj[column.dataIndex] = row[column.dataIndex];
               }
            } else {
               obj[column.dataIndex] = row[column.dataIndex];
            }
         });
         obj.actionsDropdown = (
            <ActionsDropdown
               actions={actions[i]?.length > 0 ? actions[i] : responseData?.actions}
               rowData={row}
               rowId={row.api_rowMetaData?.recordId}
               hiddenDropdown={value.buttonsInSelectMode}
               widgetContext={{
                  currentWidget: value,
                  columns: responseData?.columns,
                  showPrivateChatButtons: value?.showPrivateChatButton,
                  showPublicChatButtons: value?.showPublicChatButton,
                  chatPrivateButtonTitle: value?.chatPrivateButtonTitle,
                  chatPublicButtonTitle: value?.chatPublicButtonTitle,
               }}
               listId={value?.listId}
            />
         );
         obj.api_rowMetaData = { recordId: row?.api_rowMetaData?.recordId ?? row.ID };
         obj.key = i;
         return obj;
      });

      setColumns(columnsCopy);
      // Filtering items to only show items from your basket
      // TODO: THIS A TEMPORARY SOLUTION, NEEDS CHANGING LATER
      const query = new URLSearchParams(window.location.search);
      const basketId = query.get("basketId");
      if (basketId) {
         const yourBasket = rowsTable.filter((item) => {
            return item["ID zamówienia"] === basketId;
         });
         setRows(yourBasket);
      } else {
         setRows(rowsTable);
      }
      setLoading(false);
   };

   useEffect(() => {
      if (value && value?.listId) {
         const isV3 = value?.listId.length > 10;
         const apiWithFilter = isV3 ? getListV3 : getListV2;
         const apiWithoutFilter = isV3 ? getListV3 : getList;
         let connectionFilter;
         let listFilters;

         if (window?.location) {
            const urlParams = new URLSearchParams(window.location.search);
            listFilters = JSON.parse(decodeURIComponent(urlParams.get("listFilters")));
            connectionFilter = getConnectionData(value.id);
         }

         if (connectionFilter) {
            apiWithFilter(value?.listId, currentPage, value?.itemsPerPage, connectionFilter)
               .then(handleListResponse)
               .catch(() => {
                  apiWithoutFilter(value?.listId, currentPage, value?.itemsPerPage).then(
                     handleListResponse,
                  );
               });
         } else {
            const apiCall = listFilters?.[value.id]
               ? apiWithFilter(
                    value?.listId,
                    currentPage,
                    value?.itemsPerPage,
                    listFilters[value.id],
                 )
               : apiWithoutFilter(value?.listId, currentPage, value?.itemsPerPage);

            apiCall.then(handleListResponse).catch((err) => {
               console.log("Error in initial render with filter in URL", err);
            });
         }
      }
   }, [value, currentPage, search]);

   const handlePageChange = (page) => {
      setLoading(true);
      setCurrentPage(page);
   };

   return (
      <Widget
         title={showTitle(value.title, "", data)}
         styleName="gx-card-profile-sm"
         bgColor={value.backgroundColourHex}
         className={`${value?.hideWidgetBorder && "hidden-widget-background"}`}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={value.name}
                  widgetId={value.id}
                  icon="setting"
                  deleteIcon="true"
                  children={
                     <AdvertisementListModal
                        handleChangeDisplayOption={setDisplayOption}
                        value={value}
                        columns={columns}
                        rows={rows}
                        data={data}
                     />
                  }
               />
            )
         }
      >
         <CreateChat />

         <div
            className={`avdertisementList-container  ${
               value?.hideWidgetBorder && "hidden-widget-background"
            }`}
         >
            {value.showDisplayOptions === null ? null : value.showDisplayOptions ===
              false ? null : (
               <div className="display-options-container">
                  <RadioGroup
                     optionType="button"
                     defaultValue={displayOption}
                     onChange={(e) => setDisplayOption(e.target.value)}
                  >
                     <Radio value={"displayNormal"} className="display-normal">
                        <BorderOutlined />
                     </Radio>
                     <Radio value={"displayGrid"} className="display-grid">
                        <TableOutlined />
                     </Radio>
                     <Radio value={"displaySmall"} className="display-small">
                        <MenuOutlined />
                     </Radio>
                  </RadioGroup>
               </div>
            )}

            {rows
               ? rows.map((row, index) => (
                    <AdvertisementItem
                       key={row.api_rowMetaData?.recordId || index}
                       rows={row}
                       columns={columns}
                       buttons={row.actionsDropdown}
                       mainTitle={value.mainTitle}
                       subtitle={value.subtitle}
                       label={value.label}
                       keyInfo={value.keyInfo}
                       subKeyInfo={value.subKeyInfo}
                       user={value.user}
                       calendar={value.calendar}
                       calendarFormat={value.calendarFormat}
                       // restOfColumns are columns chosen by user to be shown as a 'rest'
                       restOfColumns={value.restOfColumns}
                       isPhotoVisible={value.isPhotoVisible}
                       showDisplayOptions={displayOption}
                       showAlignGridContentCenter={value.alignGridContentCenter}
                       buttonsInSelectMode={value.buttonsInSelectMode}
                       showMainTitleLabel={value.showMainTitleLabel}
                       showSubtitleLabel={value.showSubtitleLabel}
                       showLabelLabel={value.showLabelLabel}
                       showKeyInfoLabel={value.showKeyInfoLabel}
                       showSubKeyInfoLabel={value.showSubKeyInfoLabel}
                       showUserLabel={value.showUserLabel}
                       showCalendarLabel={value.showCalendarLabel}
                       showRestOfColumnsLabel={value.showRestOfColumnsLabel}
                       compactImageSize={value.compactImageSize}
                       previewOnClick={value.previewOnClick}
                       displayFormChildId={metaData?.displayFormChildId}
                       photoColumn={value.photoColumn}
                    />
                 ))
               : ""}
            {loading ? (
               <div id="items-loader" className="items-loader">
                  <Spin />
               </div>
            ) : null}

            <div className="pagination-container">
               {metaData?.totalPages > 1 ? (
                  <Pagination
                     defaultPageSize={value?.itemsPerPage}
                     onChange={(page) => handlePageChange(page)}
                     totalItems={metaData.totalItemsCount}
                     initialPage={currentPage}
                  />
               ) : null}
            </div>
         </div>
      </Widget>
   );
};

export default AdvertisementListWidget;
